import { ModalService } from '@app/plugins/iview-modal-modify/service';
import Form from './form.vue';
import i18n from '@app/plugins/i18n';

class GeneralModalServiceClass extends ModalService {
  constructor() {
    super(null);
  }

  popup(file_name) {
    return this.$open({
      title: i18n.t('notify.notification.export_type.not_enough_money'),
      width: this.size.confirm,
      hide_footer: true,
      showCancel: false,
      className: 'zorra-modal-dark-overlay',
      render: (h) =>
        h(Form, {
          props: {
            file_name
          },
          on: {
            success: () => {
              this.$emit('success');
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new GeneralModalServiceClass();
export { instance as GeneralModalService };
